import styled from "styled-components"
import { NeutralTextLink } from "../../../ui/components/link/link.component"

export const Logo = styled.img`
  width: 120px;
`

export const SocialLinks = styled.div`
  margin-top: 20px;

  ${NeutralTextLink} {
    line-height: 1em;
    display: inline-block;
    margin-right: 15px;
    @media (max-width: ${({ theme }) => theme.breakpoint.mobile}px) {
      font-size: ${20 / 16}rem;
    }
  }
`

export const SocialIcon = styled.img`
  height: 23px;
`

export const SocialWrapper = styled.div`
  grid-area: Social;
  display: flex;
  flex-direction: column;

  @media (min-width: 415px) {
    align-items: flex-start;
    justify-content: flex-start;
  }
`
